import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';
import { Application, Feature } from '@frontend/functionality/types';

export interface IReview {
    delete_timestamp: string | null;
    outcome: ReviewOutcome;
    application: Application | null;
    feature: Feature | null;
    expected: string | number | null;
    actual: string | number | null;
    spot_id: string | null;
    update_timestamp: string;
    product_id: string;
    user_id: string;
    id: string;
    account_id: string;
    creation_timestamp: string;
}

export interface CreateReview {
    outcome: ReviewOutcome;
    product_id: string;
    application?: Application | null;
    feature?: Feature | null;
    expected?: string | number | null;
    actual?: string | number | null;
    user_id?: string;
    update_timestamp?: string;
    spot_id?: string | null;
}

export interface UpdateReview {
    outcome?: ReviewOutcome | null;
    application?: Application | null;
    feature?: Feature | null;
    expected?: string | number | null;
    actual?: string | number | null;
    update_timestamp?: string;
    null_fields?: string[] | null;
    spot_id?: string | null;
}

export enum ReviewOutcome {
    DAMAGED = 'damaged',
    MISSING = 'missing',
    OK = 'ok',
    WRONG = 'wrong'
}

export type ReviewListResponse = PaginatedResponse<IReview>;

enum QueryParams {
    ACCOUNT_ID = 'account_id',
    PRODUCT_ID = 'product_id',
    USER_ID = 'user_id',
    OUTCOME = 'outcome',
    APPLICATION = 'application',
    FEATURE = 'feature'
}

export type ReviewQueryParams = QueryParams | DefaultQueryParams;
